export default function Getting_Started() {
  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold mb-4">Getting Started</h1>
      <div className="text-lg"><h2>Getting Started Overview</h2></div>
      <p className="mt-4 text-gray-500 text-sm">Path: /git/topic/Getting_Started</p>
    </div>
  );
}
